import { render } from "./PcsmsLogin.vue?vue&type=template&id=61285fb2&scoped=true"
import script from "./PcsmsLogin.vue?vue&type=script&lang=js"
export * from "./PcsmsLogin.vue?vue&type=script&lang=js"

import "./PcsmsLogin.vue?vue&type=style&index=0&id=61285fb2&scoped=true&lang=less"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61285fb2"]])

export default __exports__